import { relate } from '@/utils/Relationships';

export const relationships = (axios, { fields } = {}) => {
    axios.interceptors.response.use(relate(fields, {
        beforeRelate: (data) => data.relationships || data.relationship,
    }))
}